// eslint-disable-next-line
// @ts-nocheck
import FilterList from './filterList';
import intl from '../core/intl';
import getResource from '../core/resources';

const dropdownMaxHeight = 210;
const hours = 24;
const midnightISO = '00:00:00';
const padNumber = (number) => {
	if (number < 10) {
		return '0' + number;
	}
	return number;
};
const splitToParts = (str, delimiter) => {
	const index = str.indexOf(delimiter);
	const firstPart = str.substring(0, index);
	const secondPart = str.substring(index + 1);

	return [firstPart, secondPart];
};
const arabicNumberingSystem = {
	arab: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
	arabext: ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
};

export default class TimePicker extends FilterList {
	connectedCallback() {
		super.connectedCallback();
		this.setAttribute('mode', 'input-a');
		this.value = midnightISO;
	}

	initialize() {
		super.initialize();
		const list = this._createHours();
		this.validation = true;
		this.setState({ list });
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const timePicker = this;
		this.state = {
			...this.state,
			set value(isoTime) {
				if (!isoTime) {
					return;
				}

				const time = timePicker._formatTime(isoTime);
				timePicker.setState({ label: time });
			}
		};
	}

	_createHours() {
		const list = Array.from(new Array(hours), (item, hour) => {
			hour = padNumber(hour);
			const isoTime = `${hour}:00:00`;
			const time = this._formatTime(isoTime);

			return { label: time, value: isoTime };
		});

		return list;
	}

	_getInputTemplate() {
		const input = super._getInputTemplate();
		input.attrs['aria-label'] = getResource('time_picker.aria_label');
		input.events = {
			...input.events,
			onchange: (e) => {
				if (!(e instanceof CustomEvent)) {
					e.stopPropagation();
					return;
				}

				const predictedValue = this.state.predictedValue;
				predictedValue && this.setState({ value: predictedValue });
				const invalid = !this.validate();
				this.setState({ invalid });
				const isoTime = !invalid
					? this._convertTimeToISO(this.state.label)
					: '';
				this.value = isoTime;
			}
		};
		return input;
	}

	_getDropdownHeight() {
		const itemHeight = this._getItemHeight();
		const totalHeight = this.state.count * itemHeight;

		return Math.min(totalHeight, dropdownMaxHeight);
	}

	_formatTime(isoTime) {
		const [hours, minutes, seconds] = isoTime.split(':');
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const month = currentDate.getMonth();
		const date = currentDate.getDate();
		const dateISO = intl.date.toIS0Format(
			new Date(year, month, date, hours, minutes, seconds)
		);
		const dateParsed = intl.date.parse(dateISO);
		const time = intl.date.format(dateParsed, 'longTime');

		return time;
	}

	_validateHour(hour, isTwelveHourFormat) {
		const isTwentyFourHour = hour >= 0 && hour < 24;
		const isTwelveHour = hour > 0 && hour <= 12;
		const isValid = isTwelveHourFormat ? isTwelveHour : isTwentyFourHour;

		return isValid;
	}

	_validateMinuteAndSecond(value) {
		const isValid = value >= 0 && value < 60;

		return isValid;
	}

	_validateDayPeriod(dayPeriod, localeDayPeriods) {
		dayPeriod = dayPeriod.toLowerCase();

		return localeDayPeriods.includes(dayPeriod);
	}

	_convertTimeToISO(time) {
		const isTwelveHourFormat = intl.date.isHour12();
		time = time.toLowerCase();
		time = this._checkForArabic(time);
		time = this._parseTime(time);
		let hour = +time.hour;
		let minute = +time.minute;
		let second = +time.second;
		if (isTwelveHourFormat) {
			const dayPeriod = time.dayPeriod;
			if (dayPeriod === time.beforeMidnightPeriod && hour < 12) {
				hour += 12;
			} else if (dayPeriod === time.afterMidnightPeriod && hour === 12) {
				hour = 0;
			}
		}

		hour = padNumber(hour);
		minute = padNumber(minute);
		second = padNumber(second);

		return `${hour}:${minute}:${second}`;
	}

	_getTimeParts() {
		const isoDate = '2020-09-01';
		const beforeMidnight = intl.date.parse(`${isoDate}T23:00:00Z`);
		const afterMidnight = intl.date.parse(`${isoDate}T01:00:00Z`);
		const options = {
			timeZone: 'UTC',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric'
		};
		const formatter = new Intl.DateTimeFormat(intl.locale, options);
		const beforeMidnightParts = formatter.formatToParts(beforeMidnight);
		const afterMidnightParts = formatter.formatToParts(afterMidnight);
		const order = beforeMidnightParts
			.filter((part) => part.type !== 'literal')
			.map((part) => part.type);
		const delimiters = beforeMidnightParts
			.filter((part) => part.type === 'literal')
			.map((part) => part.value);
		const beforeMidnightPeriod = beforeMidnightParts
			.find((part) => part.type === 'dayPeriod')
			?.value.toLowerCase();
		const afterMidnightPeriod = afterMidnightParts
			.find((part) => part.type === 'dayPeriod')
			?.value.toLowerCase();
		const parts = {
			order,
			delimiters,
			beforeMidnightPeriod,
			afterMidnightPeriod
		};

		return parts;
	}

	_parseTime(time) {
		const timeParts = this._getTimeParts();
		const delimiters = timeParts.delimiters;
		const order = timeParts.order;
		const result = {};
		const length = delimiters.length;
		let splitted = time;
		for (let i = 0; i < length; i++) {
			splitted = splitToParts(splitted, delimiters[i]);
			result[order[i]] = splitted[0];
			splitted = splitted[1];
		}

		result[order[length]] = splitted;
		result.beforeMidnightPeriod = timeParts.beforeMidnightPeriod;
		result.afterMidnightPeriod = timeParts.afterMidnightPeriod;

		return result;
	}

	_checkForArabic(inputValue) {
		const formatter = new Intl.DateTimeFormat(intl.locale);
		const localeOptions = formatter.resolvedOptions();
		const numberingSystem =
			arabicNumberingSystem[localeOptions.numberingSystem];
		if (numberingSystem) {
			inputValue = numberingSystem.reduce((inputValue, number, index) => {
				return inputValue.replaceAll(number, `${index}`);
			}, inputValue);
		}

		return inputValue;
	}

	inputValidate() {
		return true;
	}

	validate() {
		let inputValue = this._getCurrentInputValue();
		if (!inputValue) {
			this.value = midnightISO;
			inputValue = this.state.label;
		}

		inputValue = this._checkForArabic(inputValue);
		const isTwelveHourFormat = intl.date.isHour12();
		const time = this._parseTime(inputValue);
		const hour = time.hour;
		const minute = time.minute;
		const second = time.second;
		const isInvalid = [hour, minute, second].some((timePart) => {
			return !timePart || timePart.startsWith(' ') || timePart.endsWith(' ');
		});
		if (isInvalid) {
			return false;
		}

		const isValidHour = this._validateHour(+hour, isTwelveHourFormat);
		if (!isValidHour) {
			return false;
		}

		const isValidMinute = this._validateMinuteAndSecond(+minute);
		if (!isValidMinute) {
			return false;
		}

		if (isTwelveHourFormat) {
			const dayPeriod = time.dayPeriod;
			const isValidDayPeriod = this._validateDayPeriod(dayPeriod, [
				time.beforeMidnightPeriod,
				time.afterMidnightPeriod
			]);
			if (!isValidDayPeriod) {
				return false;
			}
		}

		const isValidSecond = this._validateMinuteAndSecond(+second);
		if (!isValidSecond) {
			return false;
		}

		return true;
	}

	getTemplate() {
		const wrapper = super.getTemplate();
		if (wrapper.attrs) {
			const invalidMessage = getResource('time_picker.invalid_message');
			wrapper.attrs['data-tooltip'] = invalidMessage;
		}

		return wrapper;
	}
}
